
import './semesters'
import './addMoreCriterium'
import './allCriteria'
import './eventsCriteria'
import './saveConfigurations'
import './seeConfigurations'
